import { haversineKm } from './haversineKm';

function readNumber(value) {
  if (typeof value === 'string' && value.trim() === '') return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

function hasSelectedCoordinates(selectedLocation) {
  return readNumber(selectedLocation && selectedLocation.latitude) !== null
    && readNumber(selectedLocation && selectedLocation.longitude) !== null;
}

function isProviderConfirmedArea(area) {
  if (!area || typeof area !== 'object') return false;
  if (area.confirmedByProvider === true) return true;
  if (area.providerConfirmed === true) return true;
  if (
    area.confirmationStatus === 'providerConfirmed'
    || area.confirmationStatus === 'provider_confirmed'
    || area.confirmationStatus === 'confirmed_by_provider'
  ) return true;
  if (area.confirmation && area.confirmation.providerConfirmed === true) return true;
  if (area.providerConfirmation && area.providerConfirmation.confirmed === true) return true;
  return false;
}

function isUsableArea(area) {
  return isProviderConfirmedArea(area)
    && readNumber(area.latitude) !== null
    && readNumber(area.longitude) !== null
    && readNumber(area.radiusKm) !== null;
}

export function matchesLocationFilter(provider, selectedLocation) {
  if (!hasSelectedCoordinates(selectedLocation)) return true;
  if (provider && provider.serviceCoverageMode === 'all') return true;

  const serviceAreas = Array.isArray(provider && provider.serviceAreas)
    ? provider.serviceAreas
    : [];
  const usableAreas = serviceAreas.filter(isUsableArea);

  if (serviceAreas.length === 0) return true;
  if (usableAreas.length === 0) return false;

  return usableAreas.some((area) => {
    return haversineKm(area, selectedLocation) <= readNumber(area.radiusKm);
  });
}
